import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Handle retrieve all (booked)
export const handleRetrieveBookedWebinars = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      type: data?.type || null,
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/user/webinar/booked/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)
export const handleRetrieveUserBookedWebinars = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      type: data?.type || null,
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/user/webinar/user-booked/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)